import { useTranslation } from 'react-i18next';
import { ValidationDetail, ValidationSelectOption, ValidationSectionId } from 'models/validation';
  import {
    Button, CircularProgress, 
  } from '@mui/material';

export interface ValidationSectionSelectorComponentProps {
   isFetching: boolean;

   buttonSelection: ValidationSectionId;
   setButtonSelection: (value: ValidationSectionId) => void;

   count: ValidationSelectionCount[];
}

export interface ValidationSelectionCount {
    itemId: ValidationSectionId;
    count: number | null;
}

export interface ValidationSelectionItems {
    itemId: ValidationSectionId;
    text: string;
    subText: React.ReactElement | null;
}

function ValidationSectionSelectorComponent(props: ValidationSectionSelectorComponentProps) {
  const { t } = useTranslation(); 

  const items: ValidationSelectionItems[] = [
    {
      itemId: ValidationSectionId.DEPOSITWITHDRAWAL,
      text: t('Transfers', { ns: 'validation' }), 
      subText: null,
    },
    {
      itemId: ValidationSectionId.DUPLICATE,
      text: t('Duplicate', { ns: 'validation' }), 
      subText: null,
    },
    {
      itemId: ValidationSectionId.NEGATIVE,
      text: t('Flow Negatives', { ns: 'validation' }), 
      subText: null,
    },
    {
      itemId: ValidationSectionId.NOTICE,
      text: t('Notice', { ns: 'validation' }), 
      subText: null,
    },
    {
      itemId: ValidationSectionId.WARNING,
      text: t('Warning', { ns: 'validation' }), 
      subText: null,
    }
  ];
  
  const getCount = (forValue: ValidationSelectionItems): number | null => {
    if (!props.count) return null;
    const count = props.count.find((item) => item.itemId === forValue.itemId)?.count;
    if (count === undefined) {
      return null;
    }
    return count;
  };

  const isItemSelected = (value: ValidationSelectionItems): boolean => {
    return props.buttonSelection === value.itemId;
  };

  return (
    <>
    {items.map((item, index) => (
        <Button
        key={index}
        color="error"
        disabled={props.isFetching}
        onClick={() => {    
          props.setButtonSelection(item.itemId);
        }
      }
        variant="contained"
      >
        <span className='ct_validationSelectionSelector' style={{textDecoration: isItemSelected(item) ? 'underline' : 'none' }}>
          <span className='ct_validationSelectionSelector-item'>
            {item.text}
              {getCount(item) !== null && (
                <>
                  {' '}({getCount(item)})
                </>
              )}
              {getCount(item) === null && (
                <>
                {' '}
                <CircularProgress size={10} />
                </>
              )}
          </span>
          { item.subText && (
            <span className='ct_validationSelectionSelector-item'>
              {item.subText}
            </span>
          )}
        </span>
      </Button>
    ))}
    </>
  );
}

export default ValidationSectionSelectorComponent;
